import { useMutation, useQueryClient } from '@tanstack/react-query';
import { milestonePhaseApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useDeleteMilestoneTemplatePhase(templateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (phaseId: string) =>
      milestonePhaseApiClient.deletePhase(phaseId),
    meta: { successMessage: 'Phase removed!' },
    onSettled: () => invalidateFor('milestonePhase.save', qc, { templateId }),
  });
}
